import { queryOptions } from '@tanstack/react-query';
import {
  type GetCycledEnergyMeasurementsResponse,
  type GetCycledEnergyMeasurementsSearchParameters,
} from '../types/battery-monitoring-api';
import { batteryMonitoringApi } from '../battery-monitoring-api';

export const getCycledEnergyMeasurementsQueryOptions = (
  searchParameters: GetCycledEnergyMeasurementsSearchParameters,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- queryOptions as return type should be inferred
) =>
  queryOptions<GetCycledEnergyMeasurementsResponse>({
    queryKey: ['getCycledEnergyMeasurements', searchParameters],
    queryFn: async () => await batteryMonitoringApi.getCycledEnergyMeasurements(searchParameters),
  });
